require("reading/books/book_rating.scss");

var BookRating = function(props) {

	var maxRating = props.maxRating == undefined ? BookRating.DEFAULT_MAX_RATING : props.maxRating;

	// We may want to make these props at some point
	var iconWidth = 36;
	var iconPadding = 1; // Left and right

	var iconStyle = { width: iconWidth, paddingRight: iconPadding, paddingLeft: iconPadding };

	// We want the last star to be in a span that has all
	// earlier stars. This will help with hover functionality
	var outermostBox = undefined;

	_.times(maxRating, function(index) {
		// Opposite of index
		var rateValue = maxRating - index;
		var className = "rateIcon";
		if ((props.currentRating != null) && (rateValue <= props.currentRating)) {
			className += " active";
		}

		var onSelect = function(e) {
			if (props.onChange && rateValue != props.currentRating) {
				props.onChange(rateValue)
			}
		}

		var icon = (
			<img className={ className } onClick={ onSelect } style={ iconStyle }
				src={ require("reading/review-small.png") } key={ rateValue }  />
		);
		outermostBox = (
			<span className="nestedIconBox">{ icon }{ outermostBox }</span>
		);
	});

	var className = "bookRating";
	if (props.editable) {
		className += " editable";
	}

	if (props.currentRating && ((props.currentRating % 1) != 0)) {
		var partialValue = props.currentRating % 1;
		var leftDistance = (props.currentRating - partialValue) * iconWidth;

		var partialWrapStyle = {
			width: partialValue * iconWidth, left: leftDistance
		};

		// Make a partially filled star
		var partialIcon = (
			<span className="partialIconWrap" style={ partialWrapStyle }>
				<img className="rateIcon active" style={ { width: iconWidth } }
					src={ require("reading/review-small.png") } />
			</span>
		);
	}

	return (
		<span className={ className }>
			{ outermostBox } 
			{ partialIcon }
		</span>
	);
};

BookRating.DEFAULT_MAX_RATING = 5;

BookRating.propTypes = StrictPropTypes({
	// Max rating (i.e. number of stars). Default to BookRating.DEFAULT_MAX_RATING
	maxRating: PropTypes.number,

	// Current rating (min 1)
	currentRating: PropTypes.number,

	// If true, stars show editing behavior on hover
	editable: PropTypes.bool,

	// Passes a selected rating back up to the parent (only if it's a change)
	onChange: PropTypes.func
});

module.exports = BookRating;



// WEBPACK FOOTER //
// ./modules/components/reading/books/BookRating.js